import { exampleData } from "./feature-page";

export const developmentData = exampleData;
